export default "__VITE_ASSET__BnvSvRwm__"